import { jsx } from 'react/jsx-runtime';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { bodyStyle } from '../dialog.vanilla.mjs';

const Body = forwardRef(
  ({ className, ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      Primitive.div,
      {
        ref,
        className: classNames(className, bodyStyle),
        ...props
      }
    );
  }
);

export { Body };
//# sourceMappingURL=Body.mjs.map
